<template>
  <div class="container">
    <h2>{{ t('VIDEO UPLOAD SUCCESS') }}</h2>
    <ul class="options-container">
      <li>
        <font-awesome-icon :icon="['fas', 'check-circle']" />
        <div class="download-container">
          <span>{{ t('DOWNLOAD VIDEO LABEL') }}</span>
          <Button variant="link" :onclick="() => handleDownload()">{{ t('DOWNLOAD VIDEO') }}</Button>
        </div>
      </li>
      <li>
        <font-awesome-icon :icon="['fas', 'check-circle']" />
        <span
          >{{ t('VIDEO STUDIO INFO')
          }}<Button href="https://www.icims.com/talent-cloud-recruiting/platform/video-studio/">{{
            t('HERE')
          }}</Button></span
        >
      </li>
    </ul>
  </div>
</template>

<script lang="ts">
import { useI18n } from 'vue-i18n';
import { computed, Ref } from 'vue';
import { useStore } from 'vuex';
import { saveAs } from 'file-saver';
import Button from '@/components/Button.vue';

export default {
  name: 'Outcome',
  components: { Button },
  setup(): {
    t: (key: string) => string;
    handleDownload: () => void;
  } {
    const { t } = useI18n();
    const store = useStore();

    const handleDownload = () => {
      const file: Ref<File> = computed(() => store.getters['videos/video']);
      if (file.value && file.value.name) {
        saveAs(file.value, file.value.name);
      } else {
        console.warn('No video recorded yet');
      }
    };

    return {
      t,
      handleDownload,
    };
  },
};
</script>

<style lang="scss" scoped>
.container {
  h2 {
    margin: 0 0 1.5rem;
  }

  .options-container {
    list-style: none;
    margin: 0;
    padding: 0;

    li {
      align-items: baseline;
      display: flex;
      font-size: 1rem;

      > svg {
        color: $secondary;
        margin-right: 0.75rem;
      }

      &:not(:first-child) {
        margin-top: 0.5rem;
      }
    }

    .download-container {
      svg {
        margin-left: 0.5rem;
      }
    }

    a,
    button {
      margin-left: 0.25rem;
    }
  }
}
</style>
